(function () {
    'use strict';

    angular
        .module('Controllers')
        .controller('ConfirmationDialogCtrl', ConfirmationDialogCtrl);

    function ConfirmationDialogCtrl(dialogOptions, close, $timeout, GenericModel, lodash, $element, $rootScope) {
        var vm = this;
        var default_remote_msg_path = 'response_data.response.msg';
        var use_remote_message = lodash.get(dialogOptions, 'use_remote_message', true);
        vm.options = dialogOptions;
        vm.dismiss = dismiss;
        vm.confirm = confirm;
        vm.click = click;
        vm.remote_message = getRemoteMsg();
        vm.show = false;



        $timeout(function () {
            vm.show = true;
            getData();
        });

        function dismiss() {
            close(false, 250);
        }

        function confirm() {
            close(true, 250);
        }

        function click(event, isDismiss) {
            if (event) {
                $rootScope.$broadcast(event);
            }

            if (isDismiss) {
                dismiss();
            }
        }

        function getData() {
            if (lodash.has(dialogOptions, 'datasource')) {
                vm.loading = true;
                var endpoint = dialogOptions.datasource.url;
                var method = dialogOptions.datasource.method;

                var resource = new GenericModel(endpoint);
                resource[method](dialogOptions.response_data).$promise.then(function (res) {
                    vm.data = res.data;
                    vm.loading = false;
                });
            }
        }

        function getRemoteMsg() {
            if (!use_remote_message) return false;
            var remote_msg_path = lodash.get(vm.options, 'remoteMsgPath', default_remote_msg_path);
            return lodash.get(vm.options, remote_msg_path);
        }
    }
})();